import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@/shared/components/TableElements';
import styled from 'styled-components';
import { BookingContext } from '../../../../../../context/BookingContext';

// Styled-components for styling
const Container = styled.div`
  padding: 20px;
  background-color: #f7f7f7;
  min-height: 47vh;
`;

const PaxDetailsCardWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  max-width: 990.6px;
  margin: 0 auto;
`;

const TableWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-top: 20px;
`;

const InputField = styled.input`
  width: 100%;
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  font-size: 12px;
  margin-bottom: 10px;
  &:focus {
    border-color: #007bff;
    outline: none;
  }
`;

const PaxDetailsTable = ({
  paxDetails, selectedPaxs, setSelectedPaxs, triptype,
}) => {
  const paxData = paxDetails || [];
  const { paxs, setPaxs } = useContext(BookingContext);

  // Function to extract ID from the pax name (e.g., "11-Bhumika")
  const extractIdFromName = (name) => {
    const match = name.match(/^(\d+)-/); // Regex to match digits before hyphen
    return match ? match[1] : null;
  };

  // Effect hook to clear selectedPaxs when paxDetails changes
  useEffect(() => {
    if (triptype === '1') {
      setSelectedPaxs(paxData.filter(pax => pax.flag !== 1).map(pax => pax.id));
    } else {
      setSelectedPaxs([]); // Reset selectedPaxs when triptype isn't 2
    }
  }, [paxDetails, triptype]); // Depend on both paxDetails and triptype

  // Handle individual checkbox change
  const handleCheckboxChange = (id, isChecked) => {
    setSelectedPaxs((prevSelectedPaxs) => {
      if (isChecked) {
        return [...prevSelectedPaxs, id];
      }
      return prevSelectedPaxs.filter(paxId => paxId !== id);
    });
  };

  // Handle "select all" checkbox change
  const handleSelectAllChange = (isChecked) => {
    if (isChecked) {
      setSelectedPaxs(paxData.filter(pax => pax.flag !== 1).map(pax => pax.id));
    } else {
      setSelectedPaxs([]);
    }
  };

  // Check if all pax are selected, ignoring rows with flag === 1
  const isAllSelected = paxData.filter(pax => pax.flag !== 1).length > 0
    && selectedPaxs.length === paxData.filter(pax => pax.flag !== 1).length;

  return (
    <Container>
      <PaxDetailsCardWrapper>
        {/* Table Section with Vertical Scroll */}
        <TableWrapper>
          <Table responsive hover>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={e => handleSelectAllChange(e.target.checked)}
                    style={{ 
                      width: '17px', // Adjust the width of the checkbox
                      height: '29px', // Adjust the height of the checkbox
                      transform: 'scale(0.8)', // Scale the checkbox to make it smaller
                      cursor: 'pointer', // Change the cursor to pointer to indicate it's clickable
                    }}
                  />
                </th>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone No.</th>
                <th>Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {paxData.length === 0 ? (
                <tr>
                  <td colSpan="6">No Pax details available</td>
                </tr>
              ) : (
                paxData.map((pax, index) => (
                  <tr key={pax.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedPaxs.includes(pax.id)}
                        onChange={e => handleCheckboxChange(pax.id, e.target.checked)}
                        style={{ width: '15px' }}
                        disabled={pax.flag === 1} // Disable the checkbox if flag === 1
                      />
                    </td>
                    <td>{index + 1}</td>
                    <td>{pax.pax_name || 'NA'}</td>
                    <td>{pax.email_id || 'NA'}</td>
                    <td>{pax.mobile_no || 'NA'}</td>
                    <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
                    <td>{pax.flag === 1 ? '🔴Booked' : '🟢Not Book'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </TableWrapper>
      </PaxDetailsCardWrapper>
    </Container>
  );
};

PaxDetailsTable.propTypes = {
  paxDetails: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      email_id: PropTypes.string.isRequired,
      pax_name: PropTypes.string.isRequired,
      mobile_no: PropTypes.string.isRequired,
      age_group: PropTypes.string.isRequired,
      flag: PropTypes.string, // Add flag property if necessary
    }),
  ).isRequired,
  selectedPaxs: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedPaxs: PropTypes.func.isRequired,
  triptype: PropTypes.string.isRequired,
};

export default PaxDetailsTable;

// import React, { useContext, useEffect, useState } from 'react';
// import { Button } from '@/shared/components/Button';
// import PropTypes from 'prop-types';
// import Select from 'react-select';
// import { Table } from '@/shared/components/TableElements';
// import styled from 'styled-components';
// import { BookingContext } from '../../../../../../context/BookingContext';

// // Styled-components for styling
// const Container = styled.div`
//   padding: 20px;
//   background-color: #f7f7f7;
//   min-height: 47vh;
// `;

// const PaxDetailsCardWrapper = styled.div`
//   background-color: #ffffff;
//   border-radius: 8px;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
//   padding: 20px;
//   width: 100%;
//   max-width: 990.6px;
//   margin: 0 auto;
// `;

// const TableWrapper = styled.div`
//   max-height: 300px;
//   overflow-y: auto;
//   margin-top: 20px;
// `;

// const ReactSelect = styled(Select)`
//   width: 100%;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   &:hover {
//     border-color: #007bff;
//   }
// `;

// const InputField = styled.input`
//   width: 100%;
//   padding: 8px 10px;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   margin-bottom: 10px;
//   &:focus {
//     border-color: #007bff;
//     outline: none;
//   }
// `;

// const ButtonAdd = styled(Button)`
//   background-color: #007bff;
//   color: white;
//   border: none;
//   padding: 10px 15px;
//   font-size: 14px;
//   border-radius: 4px;
//   transition: background-color 0.3s ease;
//   width: 100%;
//   margin-top: 10px;
//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const PaxDetailsTable = ({ paxDetails, selectedPaxs, setSelectedPaxs }) => {
//   const paxData = paxDetails || [];
//   const { paxs, setPaxs } = useContext(BookingContext);
//   // const [selectedPaxs, setSelectedPaxs] = useState([]);
  

//   // Function to extract ID from the pax name (e.g., "11-Bhumika")
//   const extractIdFromName = (name) => {
//     const match = name.match(/^(\d+)-/); // Regex to match digits before hyphen
//     return match ? match[1] : null;
//   };

//   // console.log(selectedPaxs);

//   // Effect hook to clear selectedPaxs when paxDetails changes
//   useEffect(() => {
//     setSelectedPaxs([]); // Reset selectedPaxs when paxDetails changes
//   }, []);

//   // Handle individual checkbox change
//   const handleCheckboxChange = (id, isChecked) => {
//     setSelectedPaxs((prevSelectedPaxs) => {
//       if (isChecked) {
//         return [...prevSelectedPaxs, id];
//       } 
//       return prevSelectedPaxs.filter(paxId => paxId !== id);
//     });
//   };

//   // Handle "select all" checkbox change
//   const handleSelectAllChange = (isChecked) => {
//     if (isChecked) {
//       setSelectedPaxs(paxData.filter(pax => pax.flag !== 1).map(pax => pax.id));
//     } else {
//       setSelectedPaxs([]);
//     }
//   };

//   // Check if all pax are selected, ignoring rows with flag === 1
//   const isAllSelected = paxData.filter(pax => pax.flag !== 1).length > 0 
//   && selectedPaxs.length === paxData.filter(pax => pax.flag !== 1).length;

//   return (
//     <Container>
//       <PaxDetailsCardWrapper>
//         {/* Table Section with Vertical Scroll */}
//         <TableWrapper>
//           <Table responsive hover>
//             <thead>
//               <tr>
//                 <th>
//                   <input
//                     type="checkbox"
//                     checked={isAllSelected}
//                     onChange={e => handleSelectAllChange(e.target.checked)}
//                     style={{ 
//                       width: '17px', // Adjust the width of the checkbox
//                       height: '29px', // Adjust the height of the checkbox
//                       transform: 'scale(0.8)', // Scale the checkbox to make it smaller
//                       cursor: 'pointer', // Change the cursor to pointer to indicate it's clickable
//                     }}
//                   />
//                 </th>
//                 <th>#</th>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Phone No.</th>
//                 <th>Type</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paxData.length === 0 ? (
//                 <tr>
//                   <td colSpan="6">No Pax details available</td>
//                 </tr>
//               ) : (
//                 paxData.map((pax, index) => (
//                   <tr key={pax.id}>
//                     <td>
//                       <input
//                         type="checkbox"
//                         checked={selectedPaxs.includes(pax.id)}
//                         onChange={e => handleCheckboxChange(pax.id, e.target.checked)}
//                         style={{ width: '15px' }}
//                         disabled={pax.flag === 1} // Disable the checkbox if flag === 1
//                       />
//                     </td>
//                     <td>{index + 1}</td>
//                     <td>{pax.pax_name}</td>
//                     <td>{pax.email_id}</td>
//                     <td>{pax.mobile_no}</td>
//                     <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </Table>
//         </TableWrapper>
//       </PaxDetailsCardWrapper>
//     </Container>
//   );
// };

// PaxDetailsTable.propTypes = {
//   paxDetails: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string.isRequired,
//       email_id: PropTypes.string.isRequired,
//       pax_name: PropTypes.string.isRequired,
//       mobile_no: PropTypes.string.isRequired,
//       age_group: PropTypes.string.isRequired,
//       flag: PropTypes.string, // Add flag property if necessary
//     }),
//   ).isRequired,
//   selectedPaxs: PropTypes.arrayOf(PropTypes.string).isRequired,
//   setSelectedPaxs: PropTypes.func.isRequired,
// };

// export default PaxDetailsTable;
